import { IRuleOverride, TypeRuleReference } from '@/interfaces/rules-engine';
import RuleModel from '@/models/rule-model';
import {
  REFERENCE_TYPE_CLIENT,
  OVERRIDE_WEIGHT_CLIENT,
  REFERENCE_TYPE_TEAM,
  OVERRIDE_WEIGHT_TEAM,
  REFERENCE_TYPE_DOCTOR,
  OVERRIDE_WEIGHT_DOCTOR,
} from '@/settings/consts/rules-engine';

export default class RuleOverrideModel extends RuleModel {
  public sobrescreve: any;
  public hierarquia: TypeRuleReference;
  public referenciaHierarquia: string;
  public unidade: any;
  public peso: string;

  constructor(_initialValues?: IRuleOverride) {
    super(_initialValues);

    const initialValues = _initialValues || {
      sobrescreve: {},
      hierarquia: REFERENCE_TYPE_CLIENT,
      referenciaHierarquia: '',
      unidade: {},
      peso: OVERRIDE_WEIGHT_CLIENT,
      ativo: true
    };

    this.sobrescreve = initialValues.sobrescreve;
    this.hierarquia = initialValues.hierarquia;
    this.referenciaHierarquia = initialValues.referenciaHierarquia;
    this.unidade = initialValues.unidade;
    this.peso = initialValues.peso;
    this.ativo = initialValues.ativo;
  }

  // @Override
  public validate(): boolean {
    return (
      !!this.sobrescreve &&
      !!this.sobrescreve.id &&
      !!this.hierarquia &&
      !!this.referenciaHierarquia &&
      !!this.unidade &&
      !!this.unidade.id &&
      !!this.descricao &&
      !!this.acao &&
      !!this.condicoes.length
    );
  }
}
